import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="footer-content">
                <div className="footer-section">
                    <h3>Vishnu Ajit</h3>
                    <p>Computer Engineering BASc, University of Waterloo</p>
                    
                    <div className="footer-social">
                        <a href="https://github.com/YeehawMcfly" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faGithub} />
                            <span>GitHub</span>
                        </a>
                        <a href="https://www.linkedin.com/in/vishnu-ajit-a56760283/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faLinkedin} />
                            <span>LinkedIn</span>
                        </a>
                        <a href="mailto:vajit@uwaterloo.ca">
                            <FontAwesomeIcon icon={faEnvelope} />
                            <span>Email</span>
                        </a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Vishnu Ajit. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;